<template>
  <h1>Cart</h1>
</template>

<script>
export default {
  components: {}, // 區域註冊
  mixins: [], // 引入
  // 深層傳遞
  provide() {
    // 傳遞
    return {}
  },
  inject: [], // 接收
  // 淺層傳遞
  props: {},
  emits: [],
  data() {
    return {}
  },
  watch: {},
  methods: {},
  created() {}
}
</script>
